export default "__VITE_ASSET__C9G_dPFp__"